// Sized for the four stacked obligation forms rather than a message list. Shared by the entity panel and,
// because the rail has one width for both occupants, the chat, so that every place hosting the forms
// agrees on how much room they need.
export function getSidePanelWidth(viewportWidth: number): number {
    if (viewportWidth >= 1920) {
        return 560;
    }
    if (viewportWidth >= 1280) {
        return 460;
    }
    return 400;
}

// Narrower than this and the obligation forms start wrapping their labels.
export const minSidePanelWidth = 360;
